import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderWrapper from "../../Header/HeaderWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";
import Spinner from "../../Spinner";
import { formatDate } from "../../../Helper/Helper";
import { SendPostRequest } from "../../../http";
import FooterWrapper from "../../Footer/FooterWrapper";

function StackedOverlayNews() {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNewsData();
    window.scrollTo(0, 0);
  }, []);

  const getNewsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("news/list");
      setNewsData(response?.data);
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="News and Updates" Image="theme-2-banner-news.webp"/>

        <div className="container">
          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner />
            </div>
          ) : newsData?.length > 0 ? (
            <div className="row blog-main-wrapper blog-style-2 py-5">
              {newsData.map((item, index) => (
                <div className="col-md-4 mb-5" key={index}>
                  <div className="item" key={item.id}>
                    <div className="blog-inner mb-4">
                      <div className="blog-thumb relative stacked-home-news-wrapper">
                        <img
                          src={item.image}
                          className="img-fluid"
                          alt={item.title}
                          onError={(e) => {
                            e.target.src = "images/blog/blog-grid/blog-grid1.jpg";
                          }}
                        />
                      </div>
                      <div className="blog-details stacked-news-detail-main">
                        <div className="top-meta">
                          <ul className="top-meta-list">
                            <li>
                              <div className="post-date text-white">
                                <Link className="side-img-news-date" to={`/news/detail/${item?.slug}`}>
                                  <i className="ti-calendar"></i> {formatDate(item?.date)}
                                </Link>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="blog-title stacked-home-news-wrapper">
                          <h4 className="margin-bottom-10">
                            <Link style={{fontSize:"20px"}} to={`/news/detail/${item?.slug}`} className="blog-name">
                              {item?.title}
                            </Link>
                          </h4>
                        </div>
                        <div className="post-desc mt-2">
                          <div className="blog-link stacked-home-news-readmore">
                            <Link
                              to={`/news/detail/${item?.slug}`}
                              className="link font-w-500"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="col-12 text-center my-5 py-5">
              <h4>No Record Available</h4>
            </div>
          )}
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default StackedOverlayNews;